import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import ArticuloItem from "./articuloItem";
import InfiniteScroll from "react-infinite-scroll-component";
import CircularProgress from "@material-ui/core/CircularProgress";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import Button from "@material-ui/core/Button";

import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from "react-responsive-carousel";
import BusquedaArticulos from "./busqueda";

const styles = (theme) => ({
  margin: {
    margin: theme.spacing.unit,
  },
  extendedIcon: {
    marginRight: theme.spacing.unit,
  },
  root: {
    flexGrow: 1,
  },
  show: {
    transform: "translateY(0)",
    transition: "transform .5s",
  },
  hide: {
    transform: "translateY(+135%)",
    transition: "transform .5s",
  },
  icon: {
    color: "#B4C4D5",
  },
  select: {
    textAlign: "left",
    font: "400 16px/23px Roboto",
    letterSspacing: "0px",
    color: "#B4C4D5",
    opacity: 1,
  },
  rootDialog: {
    zIndex: 1550,
  },
  rootContent: {
    borderRadius: "21px",
    minWidth: "300px",
  },
});

class Articulos extends React.Component {
  constructor(props) {
    super(props);

    window.scrollTo(0, 0);

    this.state = {
      indiceActual: 0,
      hasMore: true,
      shouldShow: null,
      subFiltrosSeleccionados: [],
    };

    this.lastScroll = null;

    this.handleScroll = this.handleScroll.bind(this);
  }

  componentDidUpdate = (nextProps) => {
    if (
      /*this.props.listaArticulos && nextProps.listaArticulos && */ this.props
        .cantidadArticulos !== nextProps.cantidadArticulos
    ) {
      this.setState({ hasMore: true });
    }
  };

  componentDidMount() {
    window.addEventListener("scroll", this.handleScroll, { passive: true });
    this.props.handleShowResumenPedido(true);
    this.props.handleOnShowBusqueda(true);
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
    this.props.handleShowResumenPedido(false);
    this.props.handleOnShowBusqueda(false);
  }

  handleScroll(evt) {
    const lastScroll = window.scrollY;

    if (lastScroll === this.lastScroll) {
      return;
    }

    const shouldShow =
      this.lastScroll !== null ? lastScroll < this.lastScroll : null;

    if (shouldShow !== this.state.shouldShow) {
      this.setState((prevState, props) => ({
        ...prevState,
        shouldShow,
      }));
    }

    this.lastScroll = lastScroll;
  }

  handleChangeSubFiltro = (event) => {
    let value = event.target.value;

    this.setState({ subFiltrosSeleccionados: value === "" ? [] : value });
  };

  fetchMoreData = () => {
    if (
      (this.props.cantidadArticulos &&
        this.props.cantidadArticulosFiltrados <=
          this.props.cantidadArticulos) ||
      this.props.vistaFavoritos
    ) {
      this.setState({
        hasMore: false,
      });
    } else {
      this.setState(
        {
          hasMore: true,
        },
        this.props.handleBuscarMasArticulos
      );
    }
  };

  articuloFiltrado(a) {
    return (
      this.state.subFiltrosSeleccionados.length === 0 ||
      a.listaFiltros.some(
        (r) => this.state.subFiltrosSeleccionados.indexOf(r) >= 0
      )
    );
  }

  render() {
    const { classes } = this.props;

    return (
      <div className="containerPageArticulos" style={{ marginTop: "7.5px" }}>
        {/* BANNER MOVIL */}
        {!this.props.vistaFavoritos &&
          this.props.instalacion.listaImagenesBannerMovil &&
          this.props.instalacion.listaImagenesBannerMovil.length > 0 &&
          this.props.filterBusqueda === undefined && (
            <Carousel
              className="containerCarousel"
              infiniteLoop={true}
              showArrows={false}
              showThumbs={false}
              showStatus={false}
              autoPlay={true}
              swipeable={false}
              interval={5000}
            >
              {this.props.instalacion.listaImagenesBannerMovil.map(
                (pathBanner) => {
                  return (
                    <div
                      className={`containerBanner bannerMobile ${
                        this.props.pedido === undefined ? "bannerMobileAux" : ""
                      }`}
                    >
                      <img
                        alt=""
                        className={`imgBanner ${
                          this.props.pedido !== undefined ? "imgBannerAux" : ""
                        }`}
                        src={pathBanner}
                      />
                    </div>
                  );
                }
              )}
            </Carousel>
          )}

        {/* BANNER DESKTOP */}
        {!this.props.vistaFavoritos &&
          this.props.instalacion.listaImagenesBannerDesktop &&
          this.props.instalacion.listaImagenesBannerDesktop.length > 0 &&
          this.props.filterBusqueda === undefined && (
            <Carousel
              className="containerCarousel"
              infiniteLoop={true}
              showArrows={false}
              showThumbs={false}
              showStatus={false}
              autoPlay={false}
              swipeable={false}
              interval={5000}
            >
              {this.props.instalacion.listaImagenesBannerDesktop.map(
                (pathBanner) => {
                  return (
                    <div
                      className={`containerBanner bannerMonitor ${
                        this.props.pedido === undefined
                          ? "bannerMonitorAux"
                          : ""
                      }`}
                    >
                      <img
                        alt=""
                        className={`imgBanner ${
                          this.props.pedido !== undefined ? "imgBannerAux" : ""
                        }`}
                        src={pathBanner}
                      />
                    </div>
                  );
                }
              )}
            </Carousel>
          )}

        <BusquedaArticulos
          pedido={this.props.pedido}
          filterBusqueda={this.props.filterBusqueda}
          cantidadArticulosFiltrados={this.props.cantidadArticulosFiltrados}
          buscandoCatalogo={this.props.buscandoCatalogo}
          errorBusqueda={this.props.errorBusqueda}
          vistaFavoritos={this.props.vistaFavoritos}
          ordenamiento={this.props.ordenamiento}
          handleChangeOrdenamiento={this.props.handleChangeOrdenamiento}
          handleOnClickVerTodosLosProductos={
            this.props.handleOnClickVerTodosLosProductos
          }
          getSubFiltrosArticulos={this.props.getSubFiltrosArticulos}
          subFiltrosArticulos={this.props.subFiltrosArticulos}
          handleOnChangeFiltrosArticulos={
            this.props.handleOnChangeFiltrosArticulos
          }
        />

        {/* Articulos */}
        {this.props.listadoSecciones && this.props.listadoSecciones.length > 0 && (
          <InfiniteScroll
            style={{ paddingBottom: "50px" }}
            dataLength={this.props.cantidadArticulos}
            next={this.fetchMoreData}
            hasMore={this.state.hasMore}
            loader={
              this.props.buscandoCatalogo && (
                <div className="containerMsgInfinite">
                  <CircularProgress style={{}} />
                  <div className="msgInfiniteScroll">
                    Cargando articulos...{" "}
                  </div>
                </div>
              )
            }
            endMessage={
              <p className="msgInfiniteScroll">
                {<b>No hay más artículos.</b>}
              </p>
            }
          >
            <div>
              {this.props.listadoSecciones.map((s, j) => {
                return (
                  <div>
                    {s.nombreSeccion && (
                      <div
                        className="tituloOrdenContainer"
                        style={{ marginTop: "10px" }}
                      >
                        {/* TITULO */}
                        <div className="tituloSeccion">{s.nombreSeccion}</div>
                      </div>
                    )}

                    {
                      <div className="flexCardContainer">
                        {s.listaArticulos !== undefined &&
                          s.listaArticulos.map((a, i) => {
                            return (
                              <div
                                className={`flexCard ${
                                  this.articuloFiltrado(a) ? "" : "itemHide"
                                }`}
                              >
                                <ArticuloItem
                                  usuario={this.props.usuario}
                                  item={a}
                                  instalacion={this.props.instalacion}
                                  handleOnButtonPedilo={
                                    this.props.handleOnButtonPedilo
                                  }
                                  handleOnBorrar={this.props.handleOnBorrar}
                                  pedido={this.props.pedido}
                                  imagenes={
                                    this.props.imagenesArticulos !== undefined
                                      ? this.props.imagenesArticulos[
                                          a.idArticulo
                                        ]
                                      : undefined
                                  }
                                  precioListaPedido={
                                    this.props.precioListaPedido
                                  }
                                  getBandaDePreciosCasoDos={
                                    this.props.getBandaDePreciosCasoDos
                                  }
                                  agregarQuitarUnidad={
                                    this.props.agregarQuitarUnidad
                                  }
                                  cantidadInicial={
                                    this.props.listaArticulosPedidos !==
                                      undefined &&
                                    this.props.listaArticulosPedidos[
                                      a.idArticulo
                                    ] !== undefined
                                      ? this.props.listaArticulosPedidos[
                                          a.idArticulo
                                        ]
                                      : 0
                                  }
                                  srcImgOferta={
                                    this.props.oferta &&
                                    this.props.oferta.pathSello
                                      ? this.props.oferta.pathSello
                                      : s.pathSello || a.pathSello
                                  }
                                />
                              </div>
                            );
                          })}
                      </div>
                    }
                  </div>
                );
              })}
            </div>
          </InfiniteScroll>
        )}

        {/* MODAL CONFIRMACION DE VACIAR CARRITO */}
        <Dialog
          classes={{
            root: classes.rootDialog,
            paperScrollPaper: classes.rootContent,
          }}
          open={this.props.openModalVaciarCarrito}
          onClose={this.handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          maxWidth="sm"
          fullWidth={true}
        >
          <DialogContent className="">
            <DialogContentText id="alert-dialog-description">
              <div className="textModalConfirmar">
                Seguro que quieres vaciar tu carrito?
              </div>
            </DialogContentText>

            <DialogActions
              style={{ justifyContent: "center", marginTop: "30px" }}
            >
              <Button
                onClick={() => {
                  this.props.handleOnClickVaciarCarrtio(false);
                }}
                className="btnModalVolver"
              >
                CANCELAR
              </Button>

              <Button
                onClick={() => {
                  this.props.handleOnClickVaciarCarrtio(true);
                }}
                className="btnModalConfirmar"
                autoFocus
              >
                VACIAR CARRO
              </Button>
            </DialogActions>
          </DialogContent>
        </Dialog>

        {/* MODAL AVISO DE RETIRO POR SUCURSAL */}
        <Dialog
          classes={{
            root: classes.rootDialog,
            paperScrollPaper: classes.rootContent,
          }}
          open={this.props.openModalAvisoDeRetiro}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          maxWidth="sm"
          fullWidth={true}
        >
          <DialogContent className="">
            <DialogContentText id="alert-dialog-description">
              <div className="textModalConfirmar">
                <p>
                  Cuando finalices tu compra, nos comunicaremos con vos para
                  consultarte tu preferencia de entrega:
                </p>
                <div>
                  <div>Pickup: San Jerónimo 3250 - Santa fe</div>
                  <div>Envío a domicilio: Santa Fe, Santo Tomé y Countries</div>
                </div>
              </div>
            </DialogContentText>

            <DialogActions
              style={{ justifyContent: "center", marginTop: "30px" }}
            >
              <Button
                onClick={this.props.handleOnClickCloseModalAviso}
                className="btnModalConfirmar"
                autoFocus
              >
                ENTENDIDO
              </Button>
            </DialogActions>
          </DialogContent>
        </Dialog>

        {/* MODAL OPCIONES DE PRODUCTO */}
        <Dialog
          classes={{
            root: classes.rootDialog,
            paperScrollPaper: classes.rootContent,
          }}
          open={this.props.showModalOpcionesProducto}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          maxWidth="sm"
          fullWidth={true}
        >
          <DialogContent className="modalOpcionesProducto">
            <DialogContentText id="alert-dialog-description">
              <div className="header">Opciones del producto</div>
              <div className="texto">
                Puedes cambiar las opciones elegidas para el producto desde el
                carrito de compras.
              </div>
            </DialogContentText>

            <DialogActions style={{ justifyContent: "center" }}>
              <Button
                onClick={this.props.handleOnCloseModalOpcionesProducto}
                className="btnModalConfirmar"
                autoFocus
              >
                CONTINUAR COMPRANDO
              </Button>
            </DialogActions>
          </DialogContent>
        </Dialog>
      </div>
    );
  }
}

Articulos.propTypes = {
  classes: PropTypes.object.isRequired,
  instalacion: PropTypes.object.isRequired,
  pedido: PropTypes.object.isRequired,
  idArticuloModal: PropTypes.object.isRequired,
  idPedidoDetalleModal: PropTypes.object.isRequired,
  precioListaPedido: PropTypes.object.isRequired,
  getBandaDePreciosCasoDos: PropTypes.func.isRequired,

  imagenesArticulos: PropTypes.object.isRequired,

  oferta: PropTypes.object,

  handleOnBorrar: PropTypes.func.isRequired,
  handleOnButtonPedilo: PropTypes.func.isRequired,
  handleOnButtonConfirmarPedido: PropTypes.func.isRequired,
  handleOnPedidoDetalleModalClose: PropTypes.func.isRequired,

  agregarQuitarUnidad: PropTypes.func.isRequired,
  handleShowResumenPedido: PropTypes.func.isRequired,
  handleBuscarMasArticulos: PropTypes.func.isRequired,
  filterBusqueda: PropTypes.string,
  buscandoCatalogo: PropTypes.bool.isRequired,
  listaArticulosPedidos: PropTypes.object,
  ordenamiento: PropTypes.number,
  handleChangeOrdenamiento: PropTypes.func.isRequired,
  cantidadArticulos: PropTypes.number,
  errorBusqueda: PropTypes.bool.isRequired,
  openModalVaciarCarrito: PropTypes.bool.isRequired,
  handleOnClickVaciarCarrtio: PropTypes.func.isRequired,
  handleOnShowBusqueda: PropTypes.func.isRequired,
  vistaFavoritos: PropTypes.bool.isRequired,
  openModalAvisoDeRetiro: PropTypes.bool.isRequired,
  handleOnClickCloseModalAviso: PropTypes.func.isRequired,
  handleOnClickVerTodosLosProductos: PropTypes.func.isRequired,

  showModalOpcionesProducto: PropTypes.bool,
  handleOnCloseModalOpcionesProducto: PropTypes.func,

  getSubFiltrosArticulos: PropTypes.func,
  subFiltrosArticulos: PropTypes.array,
  handleOnChangeFiltrosArticulos: PropTypes.func,
};

export default withStyles(styles)(Articulos);
